export default __webpack_public_path__ + "static/media/shurley.5fb64a19.jpg";